import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, Renderer2, Self, SimpleChanges } from '@angular/core';
import {
  GeogebraComponent,
  MathComponent,
  RadioButtonsComponent,
  TekareaComponent,
  TekinputComponent,
} from '@tekman/shared/component/generic';
import { ComponentsFactoryBuilder, ComponentsFactoryService } from '@tekman/shared/utils';

@Component({
  selector: 'render-statement',
  template: '',
  providers: [ComponentsFactoryBuilder],
})
export class RenderStatementComponent implements OnChanges, OnDestroy {
  readonly factories: ComponentsFactoryService<any>[] = [];
  readonly hostElement: Element;

  @Input() templateHtml: string;
  @Input() validate: boolean;

  @Output() renderHtml = new EventEmitter();
  @Output() inputChange = new EventEmitter<HTMLInputElement>();

  components: any[] = [TekinputComponent, GeogebraComponent, TekareaComponent, MathComponent, RadioButtonsComponent];
  private removeInputListener: () => void;

  constructor(
    @Self() private cmpFactory: ComponentsFactoryBuilder,
    elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.hostElement = elementRef.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['templateHtml'] && changes['templateHtml'].currentValue !== '') {
      if (this.removeInputListener) {
        this.removeInputListener();
        this.removeInputListener = undefined;
      }
      this.removeAllComponents();
      this.resetFactory();
      this.setTemplate();
    }
    if (changes['validate'] && changes['validate'].currentValue) {
      this.validateForm(changes['validate'].currentValue);
    }
  }

  setTemplate(): void {
    this.hostElement.innerHTML = this.templateHtml;
    this.initFactories();
    this.createAllComponents();
    this.removeInputListener = this.renderer.listen(this.hostElement, 'input', event => {
      const target = event.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') {
        this.inputChange.emit(target as HTMLInputElement);
      }
    });
    this.renderHtml.emit();
  }

  private initFactories(): void {
    this.components.forEach(c => {
      const f = this.cmpFactory.create(c);
      this.factories.push(f);
    });
  }

  private createAllComponents(): void {
    const el = this.hostElement;
    this.factories.forEach(f => {
      f.create(el);
    });
  }

  private validateForm(validate: boolean) {
    this.factories.forEach(factory => {
      factory.embeddedComponents.forEach(element => {
        element.instance.validated = validate;
        element.instance.disabled = true;
      });
    });
  }

  private removeAllComponents(): void {
    this.factories.forEach(f => f.destroy());
  }

  private resetFactory(): void {
    this.factories.length = 0;
  }

  ngOnDestroy(): void {
    this.removeAllComponents();
    if (this.removeInputListener) {
      this.removeInputListener();
      this.removeInputListener = undefined;
    }
  }
}
